import { http } from '@/api/http'
import { currentUserSchema } from '@/types/domain'

export interface RegisterPayload {
  email: string
  password: string
  displayName?: string
}

export interface LoginPayload {
  email: string
  password: string
}

/**
 * Auth endpoints (cookie session, see M1-API-CONTRACT §Auth). The backend is authoritative;
 * these helpers only marshal requests/responses. CSRF is handled transparently by `http`.
 * Return types are inferred from the zod schemas passed to `http`.
 */
export const authApi = {
  /** Primes the antiforgery cookie (hff_csrf) before any unsafe request. 204, no body. */
  csrf: () => http.get<void>('/api/auth/csrf'),

  register: (payload: RegisterPayload) =>
    http.post('/api/auth/register', payload, currentUserSchema),

  login: (payload: LoginPayload) => http.post('/api/auth/login', payload, currentUserSchema),

  logout: () => http.post<void>('/api/auth/logout'),

  me: () => http.get('/api/me', currentUserSchema),
}
